import React, { useState } from 'react';
import { connect } from "react-redux";
import { UpdateGate } from '../../../store/actions/gateActions'; 
import { Layout, Button, Col } from 'antd';
import TextField from '@material-ui/core/TextField';
import _ from 'lodash';
import validator from 'validator';
import 'antd/dist/antd.css';

const { Content, Sider } = Layout;

function GateSettings(props) {
    const { gate } = props;
    const [data, setData] = useState({
        name:           gate.name,
        address:        gate.address ?? "",
        max_id:         gate.max_id,
        greeting:       gate.greeting ?? "",
        callMsg:        gate.callMsg ?? "",
        forceCode:      gate.forceCode ?? "",
    });

    const FormChange = (e) => {
        let update = data;
        update[e.target.name] = e.target.value;
        setData( update );
    }

    return (
        <div className="col s6" id="gateSettings">
            <Col span={24}>
                <Layout className="site-layout-background" style={{ padding: '24px 0', backgroundColor: "#fff" }}>
                    <Content style={{ padding: '0 24px', minHeight: 280 }}>
                        <div className="col s12" style={{padding: "15px", marginTop: "15px"}}>
                            <TextField variant="outlined" fullWidth onChange={(e) => FormChange(e)} name="name" defaultValue={data.name} label="Site Name" />
                        </div>
                        <div className="col s12" style={{padding: "15px"}}>
                            <TextField variant="outlined" fullWidth onChange={(e) => FormChange(e)} name="address" defaultValue={data.address} label="Address" />
                        </div>
                        <div className="col s12" style={{padding: "15px"}}>
                            <TextField inputProps={{maxLength: 15}} variant="outlined" fullWidth name="max_id" onChange={(e) => FormChange(e)} defaultValue={data.max_id} label="MAX Cell Module ID" />
                        </div>
                        <div className="col s12" style={{padding: "15px"}}>
                            <TextField variant="outlined" fullWidth name="greeting" onChange={(e) => FormChange(e)} defaultValue={data.greeting} label="Greetings" />
                        </div>
                        <div className="col s12" style={{padding: "15px"}}>
                            <TextField variant="outlined" fullWidth name="callMsg" onChange={(e) => FormChange(e)} defaultValue={data.callMsg} label="Call Button Message" />
                        </div>
                        <div className="col s12" style={{padding: "15px"}}>
                            <TextField variant="outlined" fullWidth name="forceCode" onChange={(e) => FormChange(e)} defaultValue={data.forceCode} label="Force Open Code" />
                        </div>
                        <div style={{padding: "25px 20px", marginBottom: "25px"}}>
                            <Button onClick={() => props.UpdateGate(props.id, data, gate)} type="primary">Update Gate</Button>
                        </div>
                        {/* <div className="col s12">
                            <TextInput disabled name="admin_name" value={gate.admin_name} label="Admin Name" />
                        </div>
                        <div className="col s12">
                            <TextInput disabled name="admin_cell" value={gate.admin_cell} label="Admin Cell" />
                        </div>
                        <div className="col s12">
                            <TextInput disabled name="admin_password" value={gate.admin_password} label="Admin Keycode" />
                        </div> */}
                    </Content>
                    {/* <Sider className="site-layout-background" width={300} style={{backgroundColor: "#fff"}}>
                        <div style={{
                            width: "275px", 
                            display: "flex", 
                            justifyContent: "space-between", 
                            alignItems: "center", 
                            flexDirection: "column",
                            background: "#eee",
                            borderRadius: "15px",
                            marginTop: "25px",
                            minHeight: "400px",
                            paddingBottom: "25px",
                        }}>
                            <header style={{width: "100%"}}>
                                <div style={{ borderTopLeftRadius: "15px", borderTopRightRadius: "15px", textAlign: "center", backgroundColor: "#555", width: "100%", padding: "7px"}}>
                                    <img src="/logo.png" height="30px" />
                                </div>
                                <div style={{width: "100%", backgroundColor: "#777", padding: "5px", color: "yellow"}}>{data.name}</div>
                            </header>
                            <div style={{fontWeight: "bold", borderRadius: "5px", width: "100px", textAlign: "center", padding: "15px", background: "#88b06f", color: "#fff"}}>OPEN</div>
                            <div style={{textAlign: "center", padding: "7px", width: "100%", backgroundColor: "#000", textTransform: "uppercase", color: "#fff", fontWeight: "bold"}}>Status: {gate.status}</div>
                            <div style={{fontWeight: "bold", borderRadius: "5px", width: "100px", textAlign: "center", padding: "15px", background: "#ccc", color: "#fff"}}>CLOSE</div>
                            <div style={{background: "orange", padding: "7px", marginBottom: "10px"}}>Mechanical Gate Release - On</div>
                        </div>
                    </Sider> */}
                </Layout>
            </Col>
        </div>
    );
}


const mapStateToProps = (state) => {
    return { }
}

const mapDispatchToProps = (dispatch) => {
    return {
        UpdateGate: (gate_id, form_data, old) => dispatch(UpdateGate(gate_id, form_data, old)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(GateSettings);
